// extracted by mini-css-extract-plugin
export default {"wrapper":"OverviewVertical-module__wrapper___o3CH2","row":"OverviewVertical-module__row____yebn","ellipsis":"OverviewVertical-module__ellipsis___N5cZF"};